import * as Sentry from '@sentry/react';

export function initSentry() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!process.env.REACT_APP_SENTRY_DSN) return;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: 'production',
    release: process.env.REACT_APP_VERSION || 'unknown',

    // Capture 10% of sessions for performance monitoring
    tracesSampleRate: 0.1,

    // Only trace requests to the Vercel API
    tracePropagationTargets: [
      /^https:\/\/uscope-v2\.vercel\.app/,
      /^https:\/\/api\.uscope\.co/,
    ],

    // Replay: 5% of sessions, 100% on error
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: true,
        blockAllMedia: false,
      }),
    ],

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      /^Loading chunk \d+ failed/,
    ],

    beforeSend(event) {
      // Strip email addresses from breadcrumb messages
      if (event.breadcrumbs?.values) {
        event.breadcrumbs.values = event.breadcrumbs.values.map(b => {
          if (b.message?.includes('@')) b.message = '[email redacted]';
          return b;
        });
      }
      return event;
    },
  });
}
